import type {
  IRefreshOwnerContractsByMLSStaffOrgIdParams,
  IRefreshOwnerContractsByMLSStaffOrgIdRequest,
  IRefreshOwnerContractsByMLSStaffOrgIdResponse,
} from '@/app-package';
import axios from 'axios';

/**
 * POST request to trigger a refresh of owner contracts
 * for the given MLS Staff Org ID
 * @param params.mlsStaffOrgId - MLS Staff Org ID
 * @returns Promise<void>
 */
const refreshOwnerContractsByMLSStaffOrgId = async ({
  mlsStaffOrgId,
}: IRefreshOwnerContractsByMLSStaffOrgIdParams): Promise<void> => {
  const config: IRefreshOwnerContractsByMLSStaffOrgIdRequest = {
    url: `/supra/refresh_owner_contracts/${mlsStaffOrgId}`,
    method: 'post',
  };
  await axios.request<IRefreshOwnerContractsByMLSStaffOrgIdResponse>(config);
};

export default refreshOwnerContractsByMLSStaffOrgId;
